<template>
  <div class="ll-diplay-collapse-list">
    <div
      class="ll-diplay-collapse-list_title-wrap"
      :class="{'pr-35': !isClickedToFetch && itemList.length <= 0}"
      @click="$_collapseToggleClick()"
    >
      <i
        v-if="icon"
        class="leadingIcon"
        :class="icon"
      />
      <img
        v-if="iconImg"
        :src="iconImg"
        alt=""
        class="icon-img"
      >
      <div class="ll-diplay-collapse-list_title">
        {{ $t(title) }}<span
          v-if="number"
          class="title-number"
        >{{ number }}</span>
        <div
          v-if="numberList.length > 0"
          class="ll-diplay-collapse-list_title-number"
        >
          <NumberList :item-list="numberList" />
        </div>
      </div>
      <p 
        v-if="remark"
        class="ll-diplay-collapse-list_remark"
      >{{$t(remark)}}</p>
      <i
        v-if="$_isIconShow()"
        class="trailing-icon"
        :class="$_setIcon()"
      />
    </div>
    <slide-up-down
      :active="collapseActive"
      :duration="500"
    >
      <div class="ll-diplay-collapse-list_content">
        <p v-if="itemList.length === 0 && !isLoading">
          {{ $t(emptyText) }}
        </p>
        <component
          v-else
          v-for="(item,itemIndex) in itemList"
          :is="$_getComponent(item)"
          :key="itemIndex"
          :remark="item.remark"
          :itemList="item.list"
          :emptyText="emptyText"
          :title="$t(item.title)"
          :iconImg="item.iconImg"
          :leadingIcon="item.icon"
          :isLoading="item.isLoading"
          :numberList="item.numberList"
          :isCollapse="item.isCollapse"
          :isCollapsable="isCollapsable"
          :leadingIconColor="item.typeColor"
          :isShowLoadBtn="item.isShowLoadBtn"
          :isClickedToFetch="item.isClickedToFetch"
          class="mb-8"
          @list-click="$_listClick($event)"
          @load-more="$emit('load-more',{item})"
          @toggle-collapse="$emit('toggle-collapse', {item, isCollapse:$event})"
        />
        <DotLoading v-if="isLoading" />
      </div>
    </slide-up-down>
  </div>
</template>
<script>
export default {
  name: "LlDisplayCollapseList",
  props: {
    openIcon: {
      type: String,
      default: "icon-chevron-down",
    },
    closeIcon: {
      type: String,
      default: "icon-chevron-up",
    },
    number: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    iconImg: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    numberList: {
      type: Array,
      default() {
        return [];
      },
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    emptyText: {
      type: String,
      default: "",
    },
    isStart: {
      type: Boolean,
      default: false,
    },
    remark: {
      type: String,
    },
    isClickedToFetch: {
      type: Boolean,
      default: true,
    },
    isCollapsable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    collapseActive: false,
    isLoading: false,
    C_itemList: [],
  }),
  watch: {
    isStart() {
      if (!this.isStart) {
        this.collapseActive = this.isStart;
      }
    },
    itemList: {
      deep: true,
      handler() {
        this.C_itemList = this.itemList;
      },
    },
  },
  mounted() {
    this.collapseActive = this.isStart;
    this.C_itemList = this.itemList;
  },
  methods: {
    $_collapseToggleClick() {
      if (!this.isClickedToFetch && this.itemList.length === 0) return
      this.collapseActive = !this.collapseActive;
      if (this.collapseActive) {
        if (!this.isStart) {
          this.$emit("open-click");
          this.$emit("start-click");
        }
      }
    },
    $_listClick($event) {
      this.$emit("list-click", $event);
    },
    $_loadingOpen() {
      this.isLoading = true;
    },
    $_loadingClose() {
      this.isLoading = false;
    },
    $_setIcon() {
      return this.collapseActive
      ? this.closeIcon
      : this.openIcon
    },
    $_isIconShow() {
      if (this.isClickedToFetch) {
        return true
      } else {
        if (this.itemList.length > 0) {
          return true
        } else {
          return false
        }
      }
    },
    $_getComponent(item) {
      const defaultComponent = "LlDisplayList"
      return item.component
      ? item.component
      : defaultComponent
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-diplay-collapse-list";
</style>